import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue";
import _imports_0 from '@/assets/images/empty.png';
const _hoisted_1 = {
  class: ""
};
const _hoisted_2 = {
  key: 0,
  class: "tips"
};
const _hoisted_3 = {
  class: "lf"
};
const _hoisted_4 = {
  class: "tip-title"
};
const _hoisted_5 = {
  class: "c1"
};
const _hoisted_6 = {
  class: "table-wrap"
};
const _hoisted_7 = {
  key: 0,
  class: "nodata"
};
const _hoisted_8 = {
  key: 0,
  class: "state save"
};
const _hoisted_9 = {
  key: 1,
  class: "state waiting"
};
const _hoisted_10 = {
  key: 2,
  class: "state loading"
};
const _hoisted_11 = {
  key: 3,
  class: "state success"
};
const _hoisted_12 = {
  key: 4,
  class: "state success"
};
const _hoisted_13 = {
  key: 5,
  class: "state close"
};
const _hoisted_14 = {
  key: 6,
  class: "state break"
};
const _hoisted_15 = {
  key: 7,
  class: "state break"
};
const _hoisted_16 = {
  class: "curr-handler-title"
};
const _hoisted_17 = {
  key: 0,
  class: "curr-handler-body"
};
const _hoisted_18 = {
  class: "curr-handler-name center-vertical"
};
const _hoisted_19 = {
  key: 0,
  class: "curr-handler-sub"
};
const _hoisted_20 = {
  key: 1,
  class: "curr-handler-sub"
};
const _hoisted_21 = {
  class: "curr-handler-name center-vertical curr-handler-audit"
};
const _hoisted_22 = {
  class: "curr-handler-sub"
};
const _hoisted_23 = {
  class: "handler-title"
};
const _hoisted_24 = {
  class: "handler-val"
};
const _hoisted_25 = {
  class: "handler-val"
};
const _hoisted_26 = {
  class: "handler-val"
};
const _hoisted_27 = {
  class: "el-pagination-wrap"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_el_date_picker = _resolveComponent("el-date-picker");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_switch = _resolveComponent("el-switch");
  const _component_el_form = _resolveComponent("el-form");
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
  const _component_el_dropdown = _resolveComponent("el-dropdown");
  const _component_el_table_column = _resolveComponent("el-table-column");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_popover = _resolveComponent("el-popover");
  const _component_el_tooltip = _resolveComponent("el-tooltip");
  const _component_el_popconfirm = _resolveComponent("el-popconfirm");
  const _component_el_table = _resolveComponent("el-table");
  const _component_el_pagination = _resolveComponent("el-pagination");
  const _component_src_audit = _resolveComponent("src-audit");
  const _directive_has = _resolveDirective("has");
  const _directive_loading = _resolveDirective("loading");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_form, {
    inline: true
  }, {
    default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_el_form_item, {
      label: "需求名称",
      prop: "name"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: _ctx.queryParam.name,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.queryParam.name = $event),
        size: "small",
        placeholder: "请输入需求名称"
      }, null, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      label: "需求状态"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_select, {
        modelValue: _ctx.queryParam.state,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.queryParam.state = $event),
        size: "small",
        placeholder: "请选择",
        onChange: _ctx.stateSelectChange
      }, {
        default: _withCtx(() => [_createVNode(_component_el_option, {
          label: "全部",
          value: ""
        }), _createVNode(_component_el_option, {
          label: "草稿",
          value: "0"
        }), _createVNode(_component_el_option, {
          label: "待审核",
          value: "1"
        }), _createVNode(_component_el_option, {
          label: "进行中",
          value: "2"
        }), _createVNode(_component_el_option, {
          label: "已入库",
          value: "3"
        }), _createVNode(_component_el_option, {
          label: "关闭",
          value: "4"
        }), _ctx.activeTab == '1' ? (_openBlock(), _createBlock(_component_el_option, {
          key: 0,
          label: "已驳回",
          value: "6"
        })) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["modelValue", "onChange"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      label: "需求人",
      prop: "status"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: _ctx.queryParam.createrName,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _ctx.queryParam.createrName = $event),
        size: "small",
        placeholder: "请输入需求人名称"
      }, null, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      label: "创建日期"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_date_picker, {
        size: "small",
        modelValue: _ctx.queryParam.date,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _ctx.queryParam.date = $event),
        placeholder: "选择创建日期"
      }, null, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_form_item, null, {
      default: _withCtx(() => [_createVNode(_component_el_button, {
        size: "small",
        type: "primary",
        onClick: _ctx.submitForm
      }, {
        default: _withCtx(() => [...(_cache[9] || (_cache[9] = [_createTextVNode("查询", -1)]))]),
        _: 1
      }, 8, ["onClick"]), _createVNode(_component_el_button, {
        style: {
          "margin-left": "10px"
        },
        size: "small",
        onClick: _cache[4] || (_cache[4] = $event => _ctx.resetForm('queryParam'))
      }, {
        default: _withCtx(() => [...(_cache[10] || (_cache[10] = [_createTextVNode("重置", -1)]))]),
        _: 1
      })]),
      _: 1
    }), _ctx.activeTab == '1' ? (_openBlock(), _createBlock(_component_el_form_item, {
      key: 0
    }, {
      default: _withCtx(() => [_cache[11] || (_cache[11] = _createTextVNode("   待审核 ", -1)), _createVNode(_component_el_switch, {
        modelValue: _ctx.isMyAudit,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _ctx.isMyAudit = $event),
        "inline-prompt": "",
        "active-text": "是",
        onClick: _ctx.handleMyAuditQuery
      }, null, 8, ["modelValue", "onClick"])]),
      _: 1
    })) : _createCommentVNode("", true)])]),
    _: 1
  }), _ctx.activeTab == '1' ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_cache[14] || (_cache[14] = _createElementVNode("i", {
    class: "el-icon-info"
  }, null, -1)), _createElementVNode("div", _hoisted_4, [_cache[12] || (_cache[12] = _createTextVNode(" 已选择 ", -1)), _createElementVNode("b", _hoisted_5, _toDisplayString(_ctx.multiSmss.length), 1), _cache[13] || (_cache[13] = _createTextVNode(" 项 | 当前页可审需求数量：", -1)), _createElementVNode("b", null, _toDisplayString(_ctx.getCanApprCnt), 1)])]), _ctx.getCanApprCnt > 0 ? (_openBlock(), _createBlock(_component_el_dropdown, {
    key: 0,
    trigger: "click"
  }, {
    dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.smsAuditRoles, role => {
        return _withDirectives((_openBlock(), _createBlock(_component_el_dropdown_item, {
          key: role.roleId,
          onClick: $event => _ctx.showAuditDialog(role)
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(role.roleName) + "审核 ", 1)]),
          _: 2
        }, 1032, ["onClick"])), [[_directive_has, role.auth]]);
      }), 128))]),
      _: 1
    })]),
    default: _withCtx(() => [_cache[15] || (_cache[15] = _createElementVNode("span", {
      class: "el-dropdown-link rt"
    }, [_createTextVNode(" 批量审核"), _createElementVNode("i", {
      class: "el-icon-arrow-down el-icon--right rt-icon"
    })], -1))]),
    _: 1
  })) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_6, [_ctx.tableData.length == 0 ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_7, [...(_cache[16] || (_cache[16] = [_createElementVNode("img", {
    src: _imports_0,
    alt: "",
    srcset: ""
  }, null, -1), _createElementVNode("p", {
    class: "txt"
  }, "暂 无 数 据", -1), _createElementVNode("p", {
    class: "txt2"
  }, "与您相关的需求将会在此处显示", -1)]))])), [[_directive_loading, _ctx.loading]]) : _createCommentVNode("", true), _ctx.tableData.length > 0 ? _withDirectives((_openBlock(), _createBlock(_component_el_table, {
    key: 1,
    class: _normalizeClass(['table-h', _ctx.activeTab == '1' ? 'table-h-2' : 'table-h-1']),
    onSortChange: _ctx.handleSortChange,
    data: _ctx.tableData,
    onSelectionChange: _cache[6] || (_cache[6] = val => _ctx.multiSmss = val)
  }, {
    default: _withCtx(() => [_ctx.activeTab == '1' ? (_openBlock(), _createBlock(_component_el_table_column, {
      key: 0,
      type: "selection",
      width: "30",
      selectable: _ctx.selectable
    }, null, 8, ["selectable"])) : _createCommentVNode("", true), _ctx.activeTab != 'sms' ? (_openBlock(), _createBlock(_component_el_table_column, {
      key: 1,
      prop: "name",
      label: "需求名称",
      "min-width": "18%"
    })) : _createCommentVNode("", true), _ctx.activeTab == '1' ? (_openBlock(), _createBlock(_component_el_table_column, {
      key: 2,
      prop: "name",
      label: "需求名称",
      "min-width": "10%"
    })) : _createCommentVNode("", true), _ctx.activeTab == 'all' ? (_openBlock(), _createBlock(_component_el_table_column, {
      key: 3,
      prop: "type",
      label: "需求类型",
      "min-width": "8%"
    }, {
      default: _withCtx(scope => [_createTextVNode(_toDisplayString(_ctx.getDemandType(scope.row.type)), 1)]),
      _: 1
    })) : _createCommentVNode("", true), _ctx.activeTab == '1' ? (_openBlock(), _createBlock(_component_el_table_column, {
      key: 4,
      prop: "smsContent",
      label: "短信内容",
      "min-width": "28%"
    })) : _createCommentVNode("", true), _createVNode(_component_el_table_column, {
      prop: "createrName",
      label: "需求人",
      "min-width": "8%"
    }), _createVNode(_component_el_table_column, {
      prop: "state",
      label: "需求状态",
      "min-width": "8%"
    }, {
      default: _withCtx(scope => [scope.row.state == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_8, [...(_cache[17] || (_cache[17] = [_createElementVNode("div", {
        class: "state-tag save"
      }, null, -1), _createTextVNode(" 草稿 ", -1)]))])) : _createCommentVNode("", true), scope.row.state == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_9, [...(_cache[18] || (_cache[18] = [_createElementVNode("div", {
        class: "state-tag waiting"
      }, null, -1), _createTextVNode(" 待审核 ", -1)]))])) : _createCommentVNode("", true), scope.row.state == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_10, [...(_cache[19] || (_cache[19] = [_createElementVNode("div", {
        class: "state-tag loading"
      }, null, -1), _createTextVNode(" 进行中 ", -1)]))])) : _createCommentVNode("", true), scope.row.state == 3 && scope.row.type != 4 ? (_openBlock(), _createElementBlock("div", _hoisted_11, [...(_cache[20] || (_cache[20] = [_createElementVNode("div", {
        class: "state-tag success"
      }, null, -1), _createTextVNode(" 已入库 ", -1)]))])) : _createCommentVNode("", true), scope.row.state == 3 && scope.row.type == 4 ? (_openBlock(), _createElementBlock("div", _hoisted_12, [...(_cache[21] || (_cache[21] = [_createElementVNode("div", {
        class: "state-tag success"
      }, null, -1), _createTextVNode(" 已完成 ", -1)]))])) : _createCommentVNode("", true), scope.row.state == 4 ? (_openBlock(), _createElementBlock("div", _hoisted_13, [...(_cache[22] || (_cache[22] = [_createElementVNode("div", {
        class: "state-tag close"
      }, null, -1), _createTextVNode(" 关闭 ", -1)]))])) : _createCommentVNode("", true), scope.row.state == 5 ? (_openBlock(), _createElementBlock("div", _hoisted_14, [...(_cache[23] || (_cache[23] = [_createElementVNode("div", {
        class: "state-tag break"
      }, null, -1), _createTextVNode(" 挂起 ", -1)]))])) : _createCommentVNode("", true), scope.row.state == 6 ? (_openBlock(), _createElementBlock("div", _hoisted_15, [scope.row.currHandlerMap && scope.row.currHandlerMap[0] && scope.row.currHandlerMap[0].title == '素材审批' ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_cache[24] || (_cache[24] = _createElementVNode("div", {
        class: "state-tag loading"
      }, null, -1)), _cache[25] || (_cache[25] = _createTextVNode(" 进行中 ", -1))], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_cache[26] || (_cache[26] = _createElementVNode("div", {
        class: "state-tag break"
      }, null, -1)), _cache[27] || (_cache[27] = _createTextVNode(" 已驳回 ", -1))], 64))])) : _createCommentVNode("", true)]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      prop: "currHandler",
      label: "当前处理人",
      "min-width": "15%"
    }, {
      default: _withCtx(scope => [scope.row.currHandler && scope.row.currHandler.length > 0 ? (_openBlock(), _createBlock(_component_el_popover, {
        key: 0,
        placement: "bottom",
        trigger: "hover",
        width: "360"
      }, {
        reference: _withCtx(() => [_createElementVNode("div", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.currHandler, (handler, ind) => {
          return _openBlock(), _createElementBlock("div", {
            key: ind
          }, [handler && handler.length > 0 ? (_openBlock(), _createBlock(_component_el_row, {
            key: 0,
            style: {
              "display": "flex"
            }
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_23, _toDisplayString(handler[0]) + " :", 1), _createElementVNode("div", _hoisted_24, _toDisplayString(handler[1]), 1)]),
            _: 2
          }, 1024)) : _createCommentVNode("", true)]);
        }), 128))])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_16, "【" + _toDisplayString(scope.row.name) + "】当前处理人详情", 1), scope.row.currHandlerMap.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_17, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.currHandlerMap, (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            class: "curr-handler-item",
            key: scope.row.id + index
          }, [_createElementVNode("div", _hoisted_18, _toDisplayString(item.title), 1), !item.hasMap ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_createElementVNode("div", null, _toDisplayString(item.content), 1)])) : (_openBlock(), _createElementBlock("div", _hoisted_20, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.content, (value, key) => {
            return _openBlock(), _createElementBlock("div", {
              class: "sub-item",
              key: scope.row.id + key
            }, [_createElementVNode("div", _hoisted_21, _toDisplayString(key), 1), _createElementVNode("div", _hoisted_22, _toDisplayString(value), 1)]);
          }), 128))]))]);
        }), 128))])) : _createCommentVNode("", true)]),
        _: 2
      }, 1024)) : _createCommentVNode("", true)]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      prop: "planFinishDate",
      label: "时间节点",
      "min-width": "15%",
      sortable: "custom"
    }, {
      default: _withCtx(scope => [scope.row.beginTime ? (_openBlock(), _createBlock(_component_el_tooltip, {
        key: 0,
        class: "item",
        effect: "light",
        content: '创建：' + scope.row.beginTime,
        offset: 5,
        placement: "top"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_row, {
          style: {
            "display": "flex"
          }
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_25, "创建：" + _toDisplayString(scope.row.beginTime), 1)]),
          _: 2
        }, 1024)]),
        _: 2
      }, 1032, ["content"])) : _createCommentVNode("", true), scope.row.planFinishDate ? (_openBlock(), _createBlock(_component_el_tooltip, {
        key: 1,
        class: "item",
        effect: "light",
        content: '计划完成：' + scope.row.planFinishDate,
        offset: 5,
        placement: "top"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_row, {
          style: {
            "display": "flex"
          }
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_26, "计划完成：" + _toDisplayString(scope.row.planFinishDate), 1)]),
          _: 2
        }, 1024)]),
        _: 2
      }, 1032, ["content"])) : _createCommentVNode("", true)]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      prop: "optTime",
      label: "操作时间",
      "min-width": "15%",
      sortable: "custom"
    }), _createVNode(_component_el_table_column, {
      label: "操作",
      "min-width": "10%"
    }, {
      default: _withCtx(scope => [_createVNode(_component_el_button, {
        onClick: $event => _ctx.showDetail(scope.row, false),
        link: "",
        size: "small"
      }, {
        default: _withCtx(() => [...(_cache[28] || (_cache[28] = [_createTextVNode("查看 ", -1)]))]),
        _: 1
      }, 8, ["onClick"]), scope.row.state == 2 && scope.row.type == 0 ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
        key: 0,
        onClick: $event => _ctx.showDetail(scope.row, false),
        link: "",
        size: "small"
      }, {
        default: _withCtx(() => [...(_cache[29] || (_cache[29] = [_createTextVNode("审核 ", -1)]))]),
        _: 1
      }, 8, ["onClick"])), [[_directive_has, 'needs:srcAudit']]) : _createCommentVNode("", true), scope.row.type == 1 && _ctx.selectable(scope.row) ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
        key: 1,
        onClick: $event => _ctx.showDetail(scope.row, false),
        link: "",
        size: "small"
      }, {
        default: _withCtx(() => [...(_cache[30] || (_cache[30] = [_createTextVNode("审核 ", -1)]))]),
        _: 1
      }, 8, ["onClick"])), [[_directive_has, 'needs:smsAudit']]) : _createCommentVNode("", true), scope.row.state == 0 ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
        key: 2,
        onClick: $event => _ctx.showEdit(scope.row, 0),
        link: "",
        size: "small"
      }, {
        default: _withCtx(() => [...(_cache[31] || (_cache[31] = [_createTextVNode("编辑 ", -1)]))]),
        _: 1
      }, 8, ["onClick"])), [[_directive_has, 'needs:edit']]) : _createCommentVNode("", true), scope.row.state == 5 ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
        key: 3,
        onClick: $event => _ctx.handleState(scope.row, 1),
        link: "",
        size: "small"
      }, {
        default: _withCtx(() => [...(_cache[32] || (_cache[32] = [_createTextVNode("恢复 ", -1)]))]),
        _: 1
      }, 8, ["onClick"])), [[_directive_has, 'needs:resume']]) : _createCommentVNode("", true), scope.row.type == 1 && scope.row.state == 4 ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
        key: 4,
        onClick: $event => _ctx.showEdit(scope.row, 1),
        link: "",
        size: "small"
      }, {
        default: _withCtx(() => [...(_cache[33] || (_cache[33] = [_createTextVNode("复制重提 ", -1)]))]),
        _: 1
      }, 8, ["onClick"])), [[_directive_has, 'needs:copy']]) : _createCommentVNode("", true), scope.row.state < 3 || scope.row.state == 6 ? (_openBlock(), _createBlock(_component_el_popconfirm, {
        key: 5,
        title: "您确定要关闭该需求吗?",
        onConfirm: $event => _ctx.handleState(scope.row, 4)
      }, {
        reference: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
          link: "",
          size: "small"
        }, {
          default: _withCtx(() => [...(_cache[34] || (_cache[34] = [_createTextVNode("关闭", -1)]))]),
          _: 1
        })), [[_directive_has, 'needs:close']])]),
        _: 1
      }, 8, ["onConfirm"])) : _createCommentVNode("", true)]),
      _: 1
    })]),
    _: 1
  }, 8, ["class", "onSortChange", "data"])), [[_directive_loading, _ctx.loading]]) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_27, [_createVNode(_component_el_pagination, {
    onSizeChange: _ctx.handleSizeChange,
    onCurrentChange: _ctx.handleCurrentChange,
    "page-sizes": [5, 10, 20, 30, 40],
    "page-size": _ctx.paginationObj.pageSize,
    total: _ctx.paginationObj.totalSize,
    currentPage: _ctx.paginationObj.pageNo,
    "onUpdate:currentPage": _cache[7] || (_cache[7] = $event => _ctx.paginationObj.pageNo = $event),
    layout: "prev, pager, next, sizes, jumper"
  }, null, 8, ["onSizeChange", "onCurrentChange", "page-size", "total", "currentPage"])]), _createVNode(_component_src_audit, {
    visible: _ctx.auditDialogShow,
    "onUpdate:visible": _cache[8] || (_cache[8] = $event => _ctx.auditDialogShow = $event),
    auditRole: _ctx.auditRole,
    multiSrss: _ctx.auditSmss,
    onSuccess: _ctx.loadData
  }, null, 8, ["visible", "auditRole", "multiSrss", "onSuccess"])]);
}